import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { DuoPersonCirlcePlusIcon } from '../theme/Icons';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { SharingAndAccessState } from '../share-caremap/sharing-and-access/SharingAndAccessState';

export const InviteCommunityButton: FC = () => {
    const careMapState = useInstance(CareMapState);
    const sharingState = useInstance(SharingAndAccessState);

    const caremap = careMapState.getActiveCaremap();

    const canInvite = Boolean(caremap?.links.invites);

    if (!caremap || !canInvite) {
        return null;
    }

    return (
        <IonButton
            fill="clear"
            color="primary"
            data-id="invite-community-button"
            onClick={() => sharingState.open('Care Profile', { startOnAddPerson: true })}
        >
            <DuoPersonCirlcePlusIcon />&nbsp;Invite
        </IonButton>
    );
};
